import { numberCompacter } from 'utils/numbers'
import { DownTriangle, UpTriangle } from './DirectionTriangles'
import FormatNumericValue from './FormatNumericValue'
import usePrevious from 'hooks/usePrevious'

const Change = ({
  change,
  decimals,
  isPrivate,
  prefix,
  size,
  suffix,
  compact,
}: {
  change: number | null | undefined
  decimals?: number
  isPrivate?: boolean
  prefix?: string
  size?: 'small' | 'large'
  suffix?: string
  compact?: boolean
}) => {
  const previousChange = usePrevious(change)
  return change && Number.isFinite(change) ? (
    <div className="flex items-center space-x-1.5">
      {change > 0 ? (
        <UpTriangle size={size} />
      ) : change < 0 ? (
        <DownTriangle size={size} />
      ) : null}
      <p
        className={`${
          size === 'small'
            ? 'text-xs'
            : size === 'large'
              ? 'text-base'
              : 'text-sm'
        } ${
          change > 0
            ? 'text-th-up'
            : change < 0
              ? 'text-th-down'
              : 'text-th-fgd-2'
        } ${
          previousChange && Number.isFinite(previousChange)
            ? change > previousChange
              ? 'green-flash'
              : change < previousChange
                ? 'red-flash'
                : ''
            : ''
        }`}
      >
        {prefix ? prefix : ''}
        {!compact ? (
          <FormatNumericValue
            value={Math.abs(change)}
            decimals={decimals ? decimals : 2}
            isPrivate={isPrivate}
          />
        ) : (
          numberCompacter.format(Math.abs(change))
        )}
        {suffix ? suffix : ''}
      </p>
    </div>
  ) : (
    <p
      className={`font-mono font-normal ${
        size === 'small'
          ? 'text-xs'
          : size === 'large'
            ? 'text-base'
            : 'text-sm'
      }`}
    >
      {prefix ? prefix : ''}
      <FormatNumericValue
        value="0.00"
        decimals={decimals ? decimals : 2}
        isPrivate={isPrivate}
      />
      {suffix ? suffix : ''}
    </p>
  )
}

export default Change
